const popup = document.querySelector(".m52");

if (popup) {
    const content = popup.querySelector(".m52__container");
	const close = popup.querySelector(".m52__close");

	setTimeout(() => {
		popup.classList.add("m52__visible");
		document.body.style.overflow = "hidden";
	}, 1000);

	const closePopup = () => {
		popup.classList.remove("m52__visible");
		document.body.style.overflow = "visible";
        document.removeEventListener("click", clickOutside);

		setTimeout(() => {
			popup.style.display = "none";
		}, 500);
	};

    const clickOutside = (e) => {
        if (!content.contains(e.target)) closePopup();
    }

	close.addEventListener("click", closePopup);
    document.addEventListener("click", clickOutside);
}
